/**
 * integrationsService.js — cliente de las integraciones Google (Analytics + Ads).
 *
 * Pega contra /api/integrations/{provider}/* (config, solo admin) y contra los
 * endpoints de datos /api/ga/* y /api/gads/*. Los campos secretos (JSON del
 * service account, refresh token, etc.) se envían una sola vez y NUNCA vuelven.
 */

const API = process.env.REACT_APP_STRANDS_API_URL || 'http://localhost:5001';

async function jsonFetch(url, options = {}) {
  const res = await fetch(url, { cache: 'no-store', ...options });
  let data = {};
  try { data = await res.json(); } catch (_) { /* sin cuerpo */ }
  if (!res.ok) {
    const err = new Error(data.error || `HTTP ${res.status}`);
    err.status = res.status;
    err.code = data.code;
    throw err;
  }
  return data;
}

const qs = (obj) =>
  Object.entries(obj)
    .filter(([, v]) => v !== undefined && v !== null && v !== '')
    .map(([k, v]) => `${k}=${encodeURIComponent(v)}`)
    .join('&');

const postJson = (url, body) => jsonFetch(url, {
  method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body),
});

export const integrationsApi = {
  // ── Config genérica por proveedor (solo admin) ──
  getConfig: (provider, username) =>
    jsonFetch(`${API}/api/integrations/${provider}/config?${qs({ username })}`),

  saveConfig: (provider, username, values) =>
    postJson(`${API}/api/integrations/${provider}/config`, { username, values }),

  testConfig: (provider, username) =>
    postJson(`${API}/api/integrations/${provider}/config/test`, { username }),

  deleteConfig: (provider, username) =>
    jsonFetch(`${API}/api/integrations/${provider}/config?${qs({ username })}`, { method: 'DELETE' }),

  // ── Datos ──
  gaTraffic: (username, dateFrom, dateTo) =>
    jsonFetch(`${API}/api/ga/traffic?${qs({ username, date_from: dateFrom, date_to: dateTo })}`),

  gadsCampaigns: (username, dateFrom, dateTo) =>
    jsonFetch(`${API}/api/gads/campaigns?${qs({ username, date_from: dateFrom, date_to: dateTo })}`),

  // Campañas de TikTok Ads (mismo esquema de tablero que Meta: records + months).
  tiktokCampaigns: (username, dateFrom, dateTo) =>
    jsonFetch(`${API}/api/tiktok/campaigns?${qs({ username, date_from: dateFrom, date_to: dateTo })}`),

  // Overview orgánico OFICIAL de la cuenta TikTok Business (perfil + insights + videos).
  tiktokOrganicOverview: (username, dateFrom, dateTo) =>
    jsonFetch(`${API}/api/tiktok/organic/overview?${qs({ username, date_from: dateFrom, date_to: dateTo })}`),

  // Comentarios de un video propio de TikTok (bajo demanda).
  tiktokOrganicComments: (username, videoId) =>
    jsonFetch(`${API}/api/tiktok/organic/comments?${qs({ username, video_id: videoId })}`),

  // (Solo admin, opcional) canjea app_id+secret+auth_code por el access_token y lo guarda.
  tiktokOauthExchange: (username, { appId, secret, authCode }) =>
    postJson(`${API}/api/tiktok/oauth/exchange`, {
      username, app_id: appId, secret, auth_code: authCode,
    }),
};

export default integrationsApi;
